
import { useCallback } from 'react'
import { ApolloClient, InMemoryCache, useQuery} from '@apollo/client';

import { authProvider } from "../auth";
import { PATHS } from "../paths";

import { BACKEND_URL } from '../config';

import { useNavigate } from "react-router-dom";

import { REFRESH_TOKEN } from '../constants';
import { GET_ME } from '../queries/getMe';
import { REFRESH_MUTATION } from '../queries/getRefresh';

const client = new ApolloClient({
  uri: BACKEND_URL,
  cache: new InMemoryCache(),
});

const PATH_FOR_FAILED_AUTH = `${PATHS.LOGIN}`;

export const useIsAdminLoading = () => {
  let navigate = useNavigate();
  const { loading: meLoading , error: meError , data: me } = useQuery(GET_ME);
  const tryRefresh = useCallback(async () => {
      const refreshToken = localStorage.getItem(REFRESH_TOKEN);

      if (refreshToken) {
        const refreshRequest = await client.mutate({ mutation: REFRESH_MUTATION, variables: { refreshToken } });

        if (refreshRequest.errors) {
            await authProvider.signout();
            navigate(PATH_FOR_FAILED_AUTH, { replace: true });
        }

        if (refreshRequest?.data?.refresh?.success) {
            await authProvider.signin(refreshRequest?.data?.refresh?.token, refreshRequest?.data?.refresh?.refreshToken);
            navigate(0)
        }
      } else {
        navigate(PATH_FOR_FAILED_AUTH, { replace: true });
      }
  }, [navigate])

  if (((meError?.networkError) as { statusCode: number })?.statusCode === 403) {
      tryRefresh()
  }

  return [!meLoading && !meError && me.me.organisation.membership.isAdmin, meLoading];
};

export const useIsAdmin = () => {
  const [result] = useIsAdminLoading();

  return result
};
